﻿import { ListFormat } from "typescript";
import { forEach } from "../node_modules/jszip/index";
import { ov } from "./pilotgaea-web";
import { ListItem } from "./pilotgaea-web/webgl/ov/ov-BestCommentatorUI";

export type AIForecastWidgetSetting = Required<ov.Widget.WidgetSetting> & {
	/**
	 * 代理伺服器，可給代理如PROXY_URL/{URL}。
	 * @defaultValue ""
	 */
	proxy?: string;

	/**
	 * 是否在關閉Widget時清除所有物件。
	 * @defaultValue true
	 */
	clearOnClose?: boolean;

}

/**
 * AI天氣預報 Widget
 *
 * 需加入`material-icons.css`
 * ```html
 * <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">
 * ```
 * 或參照 {@link https://developers.google.com/fonts/docs/material_icons | Google Fonts Material Icons Guide} 設置離線版本。
 */
export class AIForecastWidget extends ov.Widget.BaseWidget<ov.UI.WindowUI> {
	_TerrainView: ov.TerrainView; // 要跟view拿模組
	_Proxy: string;
	_ClearOnClose: boolean;
	_ResultContainer!: HTMLDivElement;
	_datasetContainer!: HTMLDivElement;
	_ResultTabRadio!: HTMLInputElement;
	_SwitchtypeInput!: HTMLInputElement;
	_PosValueResults: ov.UI.BubbleUI[];

	// Latest Block
	_LatestUVOptions!: Array<Object>;
	_LatestScalarOptions!: Array<Object>;
	_LatestUVSelect!: HTMLSelectElement;
	_LatestScalarSelect!: HTMLSelectElement;
	_LatestUMinInput!: HTMLInputElement;
	_LatestUMaxInput!: HTMLInputElement;
	_LatestVMinInput!: HTMLInputElement;
	_LatestVMaxInput!: HTMLInputElement;
	_LatestUVNewBtn!: HTMLButtonElement;
	_LatestScalarNewBtn!: HTMLButtonElement;

	// History Block
	_HistoryEventOptions!: Array<Object>;
	_HistoryEventSelect!: HTMLSelectElement;
	_HistoryUVOptions!: Array<Object>;
	_HistoryScalarOptions!: Array<Object>;
	_HistoryUVSelect!: HTMLSelectElement;
	_HistoryScalarSelect!: HTMLSelectElement;
	_HistoryUMinInput!: HTMLInputElement;
	_HistoryUMaxInput!: HTMLInputElement;
	_HistoryVMinInput!: HTMLInputElement;
	_HistoryVMaxInput!: HTMLInputElement;
	_HistoryUVNewBtn!: HTMLButtonElement;
	_HistoryScalarNewBtn!: HTMLButtonElement;

	_FluidModule!: ov.FluidModule;
	_Timeline!: ov.Widget.Timeline;
	_TimelinePlayer!: ov.Widget.TimelinePlayer;
	_AllRecord!: object;
	_SpeedFactor!: HTMLInputElement;
	_ArrowStyle!: HTMLInputElement;
	_LineStyle!: HTMLInputElement;
	_PosValueBtn!: HTMLButtonElement;
	_ClearPosValueBtn!: HTMLButtonElement;
	_ResultList!: HTMLDivElement;

	/**
	 * 動態風場 Widget
	 * @param param 參數。
	 */
	constructor(param: AIForecastWidgetSetting) {
		super(param);
		this._TerrainView = param.view;
		this._FluidModule = this._TerrainView.getModule("fluid");
		this._Proxy = "";
		this._ClearOnClose = true;
		this._AllRecord = {};
		this._updateParameter(param);
		this._createUI();
		this._initEvent();
		this._appendToCanvas();
		this._PosValueResults = [];
		this._LoadDefaultData();
	}


	_beforeClose() {
		if (this._ClearOnClose) {
			const results = this._ResultContainer.querySelectorAll<HTMLElement>(".ov-widget-deleteBtn");
			for (let i = 0; i < results.length; i++) {
				results[i].click();
			}
		}
	}

	_updateParameter(parameter: AIForecastWidgetSetting) {
		if (!parameter) return;
		const {
			proxy, clearOnClose
		} = parameter;
		this._Proxy = typeof proxy === "string" ? proxy : this._Proxy;
		this._ClearOnClose = typeof clearOnClose === "boolean" ? clearOnClose : this._ClearOnClose;
	}

	_createUI() {
		let x = 0;
		if (this._TerrainView) {
			x = this._TerrainView.canvas.width - 600;
		}
		this._WidgetUI = new ov.UI.WindowUI({
			x: x,
			y: 50,
			title: "AI天氣預報",
			closeButton: true,
			minimizeButton: true,
			draggable: true,
			onClose: this._onClose.bind(this)
		});
		this._WidgetUI.getElement().classList.add("ov-widget-AIForecastWidget");
		this._WidgetUI.getElement().classList.add("ov-widget-unselectable");
		this._WidgetUI.getElement().classList.add("ov-widget-hideScrollBar");
		this._WidgetUI.getTitleElement().classList.add("ov-widget-header");

		this.divider = document.createElement("div");
		this.divider.classList.add("ov-widget-divider");

		this._datasetContainer = document.createElement("div");
		this._datasetContainer.classList.add("ov-widget-tabs-content");
		this._datasetContainer.classList.add("ov-widget-hideScrollBar");
		const resultContainer = this._datasetContainer.cloneNode(true) as HTMLDivElement;
		this._ResultContainer = document.createElement("div");
		this._ResultContainer.classList.add("ov-widget-scrollBar");
		this._ResultContainer.style.overflowY = "auto";
		this._ResultContainer.style.height = "100%";
		resultContainer.append(this._ResultContainer);
		const radio = document.createElement("input");
		const label = document.createElement("label");
		const t = Math.ceil(new Date().getTime() * Math.random());
		radio.classList.add("ov-widget-tabs-radio");
		label.classList.add("ov-widget-tabs-label");
		radio.name = "DTM" + t;
		radio.type = "radio";
		this._ResultTabRadio = radio.cloneNode(true) as HTMLInputElement;
		const label2 = label.cloneNode(true) as HTMLLabelElement;
		radio.checked = true;
		radio.id = "datasetTab" + t;
		this._ResultTabRadio.id = "resultTab" + t;
		label.classList.add("ov-widget-tabs-labelFirst");
		label.innerText = "資料集";
		label2.classList.add("ov-widget-tabs-labelLast");
		label2.innerText = "控制與清單";
		label.setAttribute("for", radio.id);
		label2.setAttribute("for", this._ResultTabRadio.id);

		this._SwitchtypeInput = document.createElement("input");
		this._SwitchtypeInput.setAttribute("type", "checkbox");
		this._SwitchtypeInput.style.position = "relative";
		this._SwitchtypeInput.style.top = "11px";
		this._SwitchtypeInput.checked = false;

		this._InsertSwitchContent("最新預報/歷史資料", this._SwitchtypeInput, this._datasetContainer);

		// ----------------------------------
		// LatestBlock

		const LatestBlock = document.createElement("div");
		LatestBlock.style.display = '';


		// Add URL Select (LatestUV)
		this._LatestUVOptions = [
			{
				url: "../data/earth2/latest/u1000_v1000",
				name: "uv1000 (0m)",
				lift: 0
			},
			{
				url: "../data/earth2/latest/u10m_v10m",
				name: "uv10m",
				lift: 10
			},
			{
				url: "../data/earth2/latest/u100m_v100m",
				name: "uv100m",
				lift: 100
			},
			{
				url: "../data/earth2/latest/u850_v850",
				name: "uv850 (1500m)",
				lift: 1500
			},
			{
				url: "../data/earth2/latest/u500_v500",
				name: "uv500 (5500m)",
				lift: 5500
			},
			{
				url: "../data/earth2/latest/u250_v250",
				name: "uv250 (10000m)",
				lift: 10000
			},

			{
				url: "../data/earth2/latest/u10m_v10m_tw",
				name: "uv10m (tw)",
				lift: 10
			}
		];
		this._LatestUVSelect = document.createElement("select");
		this._LatestUVSelect.classList.add("ov-widget-select");
		this._LatestUVOptions.forEach((data) => {
			const op = document.createElement("option");
			op.text = data.name;
			op.url = data.url;
			op.lift = data.lift;
			this._LatestUVSelect.append(op);
		});
		this._InsertContent("最新風場", this._LatestUVSelect, LatestBlock);

		// Add uvMin/Max UI
		this._LatestUMinInput = document.createElement("input");
		this._LatestUMinInput.setAttribute("type", "text");
		this._LatestUMinInput.style.width = "100%";
		this._LatestUMinInput.style.display = "inline-block";
		this._LatestUMinInput.style.height = "auto";
		this._LatestUMinInput.style.border = "1px solid #e9e9e9";
		this._LatestUMinInput.style.outline = "none";
		this._LatestUMinInput.style.padding = "0 0.5rem";
		this._LatestUMinInput.style.borderTopLeftRadius = "0";
		this._LatestUMinInput.style.borderTopLeftRadius = "0";
		this._LatestUMinInput.style.borderTopRightRadius = "0.28571rem";
		this._LatestUMinInput.style.borderBottomRightRadius = "0.28571rem";
		this._LatestUMinInput.style.backgroundColor = "white";
		this._LatestUMinInput.style.fontSize = "1rem";
		this._LatestUMinInput.style.color = "black";
		this._LatestUMinInput.readOnly = false;
		this._LatestUMinInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("uMin", this._LatestUMinInput, LatestBlock);	// xj3 暫時隱藏 uvMax/Min 介面 (考慮刪除)

		this._LatestUMaxInput = this._LatestUMinInput.cloneNode(false) as HTMLInputElement;
		this._LatestUMaxInput.readOnly = false;
		this._LatestUMaxInput.setAttribute("type", "text");
		this._LatestUMaxInput.style.width = "100%";
		this._LatestUMaxInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("uMax", this._LatestUMaxInput, LatestBlock);

		this._LatestVMinInput = this._LatestUMinInput.cloneNode(false) as HTMLInputElement;
		this._LatestVMinInput.readOnly = false;
		this._LatestVMinInput.setAttribute("type", "text");
		this._LatestVMinInput.style.width = "100%";
		this._LatestVMinInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("vMin", this._LatestVMinInput, LatestBlock);

		this._LatestVMaxInput = this._LatestUMinInput.cloneNode(false) as HTMLInputElement;
		this._LatestVMaxInput.readOnly = false;
		this._LatestVMaxInput.setAttribute("type", "text");
		this._LatestVMaxInput.style.width = "100%";
		this._LatestVMaxInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("vMax", this._LatestVMaxInput, LatestBlock);

		this._LatestUVNewBtn = document.createElement("button");
		this._LatestUVNewBtn.classList.add("ov-widget-btn");
		this._LatestUVNewBtn.style.width = "25%";
		this._LatestUVNewBtn.innerText = "新增風場";
		this._LatestUVNewBtn.style.marginLeft = "22.8rem";
		LatestBlock.append(this._LatestUVNewBtn);

		LatestBlock.append(this.divider.cloneNode(true));


		// Add URL Select (LatestScalar)
		this._LatestScalarOptions = [
			{
				url: "../data/earth2/latest/output_tp.tif",
				name: "tp (降雨)",
				layername: "tp"
			},
			{
				url: "../data/earth2/latest/output_t2m.tif",
				name: "t2m (地面溫度)",
				layername: "t2m"
			},
			{
				url: "../data/earth2/latest/output_tcwv.tif",
				name: "tcwv (水蒸氣)",
				layername: "tcwv"
			},
			{
				url: "../data/earth2/latest/output_r500.tif",
				name: "r500 (相對溼度)",
				layername: "r500"
			},
			{
				url: "../data/earth2/latest/output_r850.tif",
				name: "r850 (相對溼度)",
				layername: "r850"
			},

			{
				url: "../data/earth2/latest/output18_mrr.tif",
				name: "mrr_tw (台灣範圍雷達迴波)",
				layername: "mrr_tw"
			},
			{
				url: "../data/earth2/latest/output18_t2m.tif",
				name: "t2m_tw (台灣範圍地面溫度)",
				layername: "t2m_tw"
			}
		];
		this._LatestScalarSelect = document.createElement("select");
		this._LatestScalarSelect.classList.add("ov-widget-select");
		this._LatestScalarOptions.forEach((data) => {
			const op = document.createElement("option");
			op.text = data.name;
			op.url = data.url;
			op.layername = data.layername;
			this._LatestScalarSelect.append(op);
		});
		this._InsertContent("最新預報資料", this._LatestScalarSelect, LatestBlock);

		this._LatestScalarNewBtn = document.createElement("button");
		this._LatestScalarNewBtn.classList.add("ov-widget-btn");
		this._LatestScalarNewBtn.style.width = "25%";
		this._LatestScalarNewBtn.innerText = "新增預報";
		this._LatestScalarNewBtn.style.marginLeft = "22.8rem";
		LatestBlock.append(this._LatestScalarNewBtn);

		this._datasetContainer.append(LatestBlock);


		// ----------------------------------
		// HistoryBlock

		const HistoryBlock = document.createElement("div");
		HistoryBlock.style.display = 'none';

		this._HistoryEventOptions = [
			{
				name: "巴威(20260707)",
				path: "../data/earth2/20260707_00",
				date: "2026-07-07T00:00:00Z"
			},
			{
				name: "鳳凰(20251110)",
				path: "../data/earth2/20251110_00",
				date: "2025-11-10T00:00:00Z"
			},
			{
				name: "樺加沙(20250920)",
				path: "../data/earth2/20250920_00",
				date: "2025-09-20T00:00:00Z"
			},
			{
				name: "楊柳(20250811)",
				path: "../data/earth2/20250811_00",
				date: "2025-08-11T00:00:00Z"
			},
			{
				name: "范斯高+竹節草+柯羅莎(20250724)",
				path: "../data/earth2/20250724_00",
				date: "2025-07-24T00:00:00Z"
			},
			{
				name: "丹娜絲(20250704)",
				path: "../data/earth2/20250704_00",
				date: "2025-07-04T00:00:00Z"
			},
			{
				name: "蝴蝶颱風(20250611)",
				path: "../data/earth2/20250611_00",
				date: "2025-06-11T00:00:00Z"
			},
			{
				name: "天兔颱風(20241113)",
				path: "../data/earth2/20241113_18",
				date: "2024-11-13T18:00:00Z"
			},
			{
				name: "康芮颱風(20241029)",
				path: "../data/earth2/20241029_00",
				date: "2024-10-29T00:00:00Z"
			},
			{
				name: "山陀兒颱風(20240930)",
				path: "../data/earth2/20240930_18",
				date: "2024-09-30T18:00:00Z"
			}
		];
		this._HistoryEventSelect;
		this._HistoryEventSelect = document.createElement("select");
		this._HistoryEventSelect.classList.add("ov-widget-select");
		this._HistoryEventOptions.forEach((data) => {
			const op = document.createElement("option");
			op.text = data.name;
			op.path = data.path;
			op.date = data.date;
			this._HistoryEventSelect.append(op);
		});
		this._InsertContent("歷史資料集", this._HistoryEventSelect, HistoryBlock);

		HistoryBlock.append(this.divider.cloneNode(true));

		// Add URL Select (LatestUV)
		this._HistoryUVOptions = [
			{
				url: "u1000_v1000",
				name: "uv1000 (0m)",
				lift: 0
			},
			{
				url: "u10m_v10m",
				name: "uv10m",
				lift: 10
			},
			{
				url: "u100m_v100m",
				name: "uv100m",
				lift: 100
			},
			{
				url: "u850_v850",
				name: "uv850 (1500m)",
				lift: 1500
			},
			{
				url: "u500_v500",
				name: "uv500 (5500m)",
				lift: 5500
			},
			{
				url: "u250_v250",
				name: "uv250 (10000m)",
				lift: 10000
			},

			{
				url: "u10m_v10m_tw",
				name: "uv10m (tw)",
				lift: 10
			}
		];
		this._HistoryUVSelect = document.createElement("select");
		this._HistoryUVSelect.classList.add("ov-widget-select");
		this._InsertContent("歷史風場", this._HistoryUVSelect, HistoryBlock);

		// Add uvMin/Max UI
		this._HistoryUMinInput = document.createElement("input");
		this._HistoryUMinInput.setAttribute("type", "text");
		this._HistoryUMinInput.style.width = "100%";
		this._HistoryUMinInput.style.display = "inline-block";
		this._HistoryUMinInput.style.height = "auto";
		this._HistoryUMinInput.style.border = "1px solid #e9e9e9";
		this._HistoryUMinInput.style.outline = "none";
		this._HistoryUMinInput.style.padding = "0 0.5rem";
		this._HistoryUMinInput.style.borderTopLeftRadius = "0";
		this._HistoryUMinInput.style.borderTopLeftRadius = "0";
		this._HistoryUMinInput.style.borderTopRightRadius = "0.28571rem";
		this._HistoryUMinInput.style.borderBottomRightRadius = "0.28571rem";
		this._HistoryUMinInput.style.backgroundColor = "white";
		this._HistoryUMinInput.style.fontSize = "1rem";
		this._HistoryUMinInput.style.color = "black";
		this._HistoryUMinInput.readOnly = false;
		this._HistoryUMinInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("uMin", this._HistoryUMinInput, HistoryBlock);	// xj3 暫時隱藏 uvMax/Min 介面 (考慮刪除)

		this._HistoryUMaxInput = this._HistoryUMinInput.cloneNode(false) as HTMLInputElement;
		this._HistoryUMaxInput.readOnly = false;
		this._HistoryUMaxInput.setAttribute("type", "text");
		this._HistoryUMaxInput.style.width = "100%";
		this._HistoryUMaxInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("uMax", this._HistoryUMaxInput, HistoryBlock);

		this._HistoryVMinInput = this._HistoryUMinInput.cloneNode(false) as HTMLInputElement;
		this._HistoryVMinInput.readOnly = false;
		this._HistoryVMinInput.setAttribute("type", "text");
		this._HistoryVMinInput.style.width = "100%";
		this._HistoryVMinInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("vMin", this._HistoryVMinInput, HistoryBlock);

		this._HistoryVMaxInput = this._HistoryUMinInput.cloneNode(false) as HTMLInputElement;
		this._HistoryVMaxInput.readOnly = false;
		this._HistoryVMaxInput.setAttribute("type", "text");
		this._HistoryVMaxInput.style.width = "100%";
		this._HistoryVMaxInput.placeholder = "預設: (參照各高度預設值)";
//		this._InsertContent("vMax", this._HistoryVMaxInput, HistoryBlock);

		this._HistoryUVNewBtn = document.createElement("button");
		this._HistoryUVNewBtn.classList.add("ov-widget-btn");
		this._HistoryUVNewBtn.style.width = "25%";
		this._HistoryUVNewBtn.innerText = "新增風場";
		this._HistoryUVNewBtn.style.marginLeft = "22.8rem";
		HistoryBlock.append(this._HistoryUVNewBtn);

		HistoryBlock.append(this.divider.cloneNode(true));

		// ----------------------------------
		// HistoryScalar
		this._HistoryScalarOptions = [
			{
				url: "output_tp.tif",
				name: "tp (降雨)",
				layername: "tp"
			},
			{
				url: "output_t2m.tif",
				name: "t2m (地面溫度)",
				layername: "t2m"
			},
			{
				url: "output_tcwv.tif",
				name: "tcwv (水蒸氣)",
				layername: "tcwv"
			},
			{
				url: "output_r500.tif",
				name: "r500 (相對溼度)",
				layername: "r500"
			},
			{
				url: "output_r850.tif",
				name: "r850 (相對溼度)",
				layername: "r850"
			},

			{
				url: "output18_mrr.tif",
				name: "mrr_tw (台灣範圍雷達迴波)",
				layername: "mrr_tw"
			},
			{
				url: "output18_t2m.tif",
				name: "t2m_tw (台灣範圍地面溫度)",
				layername: "t2m_tw"
			}
		];
		this._HistoryScalarSelect = document.createElement("select");
		this._HistoryScalarSelect.classList.add("ov-widget-select");
		this._InsertContent("歷史預報資料", this._HistoryScalarSelect, HistoryBlock);

		this._HistoryScalarNewBtn = document.createElement("button");
		this._HistoryScalarNewBtn.classList.add("ov-widget-btn");
		this._HistoryScalarNewBtn.style.width = "25%";
		this._HistoryScalarNewBtn.innerText = "新增預報";
		this._HistoryScalarNewBtn.style.marginLeft = "22.8rem";
		HistoryBlock.append(this._HistoryScalarNewBtn);

		this._datasetContainer.append(HistoryBlock);


		// ----------------------------------
		// General Control

		this._SpeedFactor = this._HistoryUMinInput.cloneNode(false) as HTMLInputElement;
		this._SpeedFactor.readOnly = false;
		this._SpeedFactor.setAttribute("type", "text");
		this._SpeedFactor.style.width = "100%";
		this._SpeedFactor.value = "0.8";
		this._InsertContent("風場速度係數", this._SpeedFactor, this._ResultContainer);

		this._SpeedFactor.onchange = (event) => {
			this._FluidModule.speedFactor = parseFloat(this._SpeedFactor.value);
		};

		const uniqueName = `styleOption_${Math.random().toString(36).substr(2, 9)}`;

		// 建立箭頭的 radio button
		this._ArrowStyle = document.createElement("input");
		this._ArrowStyle.setAttribute("type", "radio");
		this._ArrowStyle.setAttribute("name", uniqueName); // 確保兩個按鈕是同一組
		this._ArrowStyle.setAttribute("value", "arrow");
		this._ArrowStyle.id = "arrowOption";
		this._ArrowStyle.style.width = "1.2rem";
		this._ArrowStyle.style.height = "1.2rem";
		this._ArrowStyle.style.marginRight = "1rem";

		// 建立箭頭的 label，作為容器
		const arrowLabel = document.createElement("label");
		// arrowLabel.setAttribute("for", "arrowOption");
		arrowLabel.style.fontSize = "1rem";
		arrowLabel.style.display = "flex";
		arrowLabel.style.alignItems = "center";
		arrowLabel.style.color = "black";

		// 把 radio button 和文字一起加入到 label
		arrowLabel.appendChild(this._ArrowStyle);
		arrowLabel.appendChild(document.createTextNode("箭頭"));

		this._ArrowStyle.onchange = (event) => {
			this._FluidModule.mode = 2;
		};

		// 建立線條的 radio button
		this._LineStyle = document.createElement("input");
		this._LineStyle.setAttribute("type", "radio");
		this._LineStyle.setAttribute("name", uniqueName);
		this._LineStyle.setAttribute("value", "line");
		this._LineStyle.id = "lineOption";
		this._LineStyle.style.width = "1.2rem";
		this._LineStyle.style.height = "1.2rem";
		this._LineStyle.style.marginRight = "1rem";
		this._LineStyle.checked = true;


		// 建立線條的 label
		const lineLabel = document.createElement("label");
		// lineLabel.setAttribute("for", "lineOption");
		lineLabel.style.fontSize = "1rem";
		lineLabel.style.display = "flex";
		lineLabel.style.alignItems = "center";
		lineLabel.style.color = "black";

		// 把 radio button 和文字一起加入到 label
		lineLabel.appendChild(this._LineStyle);
		lineLabel.appendChild(document.createTextNode("線條"));

		this._LineStyle.onchange = (event) => {
			this._FluidModule.mode = 1;
		};

		// 包裝按鈕與標籤的容器
		const fluidstyle = document.createElement("div");
		fluidstyle.style.width = "100%";
		fluidstyle.style.display = "flex";
		fluidstyle.style.gap = "1rem";
		fluidstyle.style.marginLeft = "1rem";
		// fluidstyle.appendChild(this._ArrowStyle);
		fluidstyle.appendChild(arrowLabel);
		// fluidstyle.appendChild(this._LineStyle);
		fluidstyle.appendChild(lineLabel);

		this._InsertContent("風場呈現樣式", fluidstyle, this._ResultContainer);

		// 預報數值查詢
		this._PosValueBtn = document.createElement("button");
		this._PosValueBtn.classList.add("ov-widget-btn");
		this._PosValueBtn.innerText = "查詢單點數值";

		this._ClearPosValueBtn = document.createElement("button");
		this._ClearPosValueBtn.classList.add("ov-widget-btn");
		this._ClearPosValueBtn.innerText = "清除查詢結果";

		const posValueSection = document.createElement("div");
		posValueSection.style.width = "100%";
		posValueSection.style.display = "flex";
		posValueSection.style.gap = "1rem";
		posValueSection.style.marginLeft = "1rem";
		posValueSection.appendChild(this._PosValueBtn);
		posValueSection.appendChild(this._ClearPosValueBtn);
		this._InsertContent("預報數值查詢", posValueSection, this._ResultContainer);

		this._ResultContainer.append(this.divider.cloneNode(true));

		// 預報及風場資料清單
		this._ResultList = document.createElement("div");
		this._ResultContainer.append(this._ResultList);

		const mainContainer = this._WidgetUI.getContentElement();
		mainContainer.classList.add("ov-widget-tabs");
		mainContainer.append(radio);
		mainContainer.append(label);
		mainContainer.append(this._datasetContainer);
		mainContainer.append(this._ResultTabRadio);
		mainContainer.append(label2);
		mainContainer.append(resultContainer);


		// UI Update Func.
		this._SwitchtypeInput.addEventListener("change", (event) => {
			this._reset();
			HistoryBlock.style.display = this._SwitchtypeInput.checked ? '' : 'none';
			LatestBlock.style.display = this._SwitchtypeInput.checked ? 'none' : '';
		});

		this._HistoryEventSelect.addEventListener("change", (event) => {

			this._reset();

			let path = this._HistoryEventSelect.options[this._HistoryEventSelect.selectedIndex].path;

			// Clean HistoryUV and Create new Options
			for (let i = this._HistoryUVSelect.options.length - 1; i >= 0; i--)
			{
				this._HistoryUVSelect.remove(i);
			}
			this._HistoryUVOptions.forEach((data) => {
				const op = document.createElement("option");
				op.text = data.name;
				op.url = path + "/" + data.url;
				op.lift = data.lift;
				this._HistoryUVSelect.append(op);
			});

			// Clean HistoryScalar and Create new Options
			for (let i = this._HistoryScalarSelect.options.length - 1; i >= 0; i--)
			{
				this._HistoryScalarSelect.remove(i);
			}
			this._HistoryScalarOptions.forEach((data) => {
				const op = document.createElement("option");
				op.text = data.name;
				op.url = path + "/" + data.url;
				op.layername = data.layername;
				this._HistoryScalarSelect.append(op);
			});
		});

		this._HistoryEventSelect.dispatchEvent(new Event('change'));
	}


	_InsertContent(label: string, content: HTMLElement, container: HTMLElement) {
		const innerContainer = document.createElement("div");
		innerContainer.classList.add("ov-widget-inputContainer");
		innerContainer.style.marginBottom = "1rem";

		const labelContainer = document.createElement("div");
		labelContainer.classList.add("ov-widget-inputTitle");
		labelContainer.innerText = label;
		innerContainer.append(labelContainer);

		innerContainer.append(content);

		container.append(innerContainer);
	}

	_InsertSwitchContent(label: string, content: HTMLElement, container: HTMLElement) {
		const innerContainer = document.createElement("div");
		innerContainer.classList.add("ov-widget-inputContainer");
		innerContainer.style.marginBottom = "1rem";

		content.classList.add("ov-widget-switch");
		content.id = "Switch " + label;
		const labelContainer = document.createElement("div");
		labelContainer.classList.add("ov-widget-inputTitle");
		const labelEle = document.createElement("label");
		labelEle.innerText = label;
		labelEle.setAttribute("for", content.id);
		labelContainer.append(labelEle);

		innerContainer.append(labelContainer);
		innerContainer.append(content);

		container.append(innerContainer);

	}


	_initEvent()
	{
		this._LatestUVNewBtn.addEventListener("click", () =>
		{
			let url = this._LatestUVSelect.options[this._LatestUVSelect.selectedIndex].url;
			let lift = this._LatestUVSelect.options[this._LatestUVSelect.selectedIndex].lift;
			this._LoadNewUVData(url, lift);
		});

		this._LatestScalarNewBtn.addEventListener("click", async () =>
		{
			let url = this._LatestScalarSelect.options[this._LatestScalarSelect.selectedIndex].url;

			let layer = this._LatestScalarSelect.options[this._LatestScalarSelect.selectedIndex].layername;
			if (this._AllRecord[layer] !== undefined)
			{
				ov.UI.Alertify.Error("該層資料已讀取!");
				return;
			}

			let date = await this._GetDateForScalarFile(url);	// ex. "2024-11-13T18:00:00Z"
			if (date === null)
			{
				ov.UI.Alertify.Error("檔案來源有誤!");
				return;
			}

			this._LoadNewScalarData(url, date, layer);
		});

		this._HistoryUVNewBtn.addEventListener("click", async () =>
		{
			let url = this._HistoryUVSelect.options[this._HistoryUVSelect.selectedIndex].url;
			let lift = this._HistoryUVSelect.options[this._HistoryUVSelect.selectedIndex].lift;
			this._LoadNewUVData(url, lift);
		});

		this._HistoryScalarNewBtn.addEventListener("click", async () =>
		{
			let url = this._HistoryScalarSelect.options[this._HistoryScalarSelect.selectedIndex].url;
			let layer = this._HistoryScalarSelect.options[this._HistoryScalarSelect.selectedIndex].layername;
			let date = this._HistoryEventSelect.options[this._HistoryEventSelect.selectedIndex].date;
			this._LoadNewScalarData(url, date, layer);
		});

		this._PosValueBtn.addEventListener("click", (event) => {
			ov.UI.Alertify.Notify("點擊圖台查詢");
			this._TerrainView.inputSurfacePoint({
				onCompleted: (ret) => {
					if (ret && ret.geo) {
						let content = "<h4>" + "經度:" + ret.geo.x.toFixed(8) + "<br>緯度:" + ret.geo.y.toFixed(8) + "<br>";

						for (let i = 0; i < Object.keys(this._AllRecord).length; i++)
						{
							let key = Object.keys(this._AllRecord)[i];
							let para = this._AllRecord[key];

							if (!para.isVector)	// Scalar Data
							{
								// Get Value of OverLay
								let value = 0;
								let value0 = para.overlay[0].getValue(ret.geo, true);	// lerp: 是否內插，否則取最接近的點。預設否。
								let value1 = para.overlay[1].getValue(ret.geo, true);
								(value0 !== null) ? value = value0 : value = value1;	// 因 oview 處理全球 overlay 分東西半球，要看點位落於哪邊
								if (para.layername === 't2m')	// t2m 需特案處理
									value -= 273.15;			// K to 攝氏

								content += "[" + para.layername + "] " + value.toFixed(4) + "<br>";
							}
							else	// UV Data
							{
								let value = this._FluidModule.getFluidSpeed(ret.geo);
								let speedMS = this._CalUVWindSpeed(value.x, value.y);

								if (parseInt(key) >= 1500)
								{
									// Show Orig Value (1500m 以上高度，顯示原始風量)
									content += "[UV-" + key + "] " + speedMS.toFixed(4) + " m/s<br>";
									content += "( " + value.x.toFixed(4) + ", " + value.y.toFixed(4) + ")<br>";
								}
								else
								{
									// Show Beaufort Scale (0~100m，顯示蒲福風級)
									let speedBFS = this._CalUVBeaufortScale(speedMS);
									let direct = this._CalUVWindDirection(value.x, value.y);
									content += "[UV-" + key + "] " + speedBFS + " 級風 (N->" + direct.toFixed(0) + "°)<br>";
								}
							}
						}
						content += "</h4>";

						// Gen Bubble UI
						const bubble = new ov.UI.BubbleUI({
							title: "查詢結果",
							width: 200,
							height: 180,
							x: ret.geo.x,
							y: ret.geo.y,
							z: 0,
							lockPointHorizontal: "middle",
							lockPointVertical: "bottom",
							arrowColor: "#EDE8F8"
						});
						bubble.getElement().classList.add("ov-widget-seabed-bubble");
						bubble.getTitleElement().classList.add("ov-widget-header");
						bubble.getContentElement().classList.add("ov-widget-seabed-bubble-content");
						bubble.appendContent(content);

						this._PosValueResults.push(bubble);
						this._TerrainView.addUI(bubble);
					}
				}
			});
		});

		this._ClearPosValueBtn.addEventListener("click", this.removeAllPosValueResults.bind(this));
	}
	async _LoadNewUVData(url, lift)
	{
		let uvPara =
		{
			source: "earth2",
			width: 1440,
			height: 720,
			depth: 1,
			speedFactor: 0.8,
			lift: lift,
			uMin: [],
			uMax: [],
			vMin: [],
			vMax: [],
			date: [],		// defined in setFluidDataByParam
			image: [],	// defined in setFluidDataByParam
			url: "",
			filenames: [],
			isVector: true,	// UV: Vector; Others: Scalar
			btnUI: null,
//			boundary: null
		};

		// Get file list
		uvPara.url = url;
		uvPara.filenames = await this._GetUVPngList(uvPara.url);
		if (!uvPara.filenames.length) {
			ov.UI.Alertify.Error("檔案來源有誤!");
			return;
		}

		// tw_data 
		if (url.indexOf("_tw") !== -1)
		{
			uvPara.boundary = new window.GeoBoundary(116.137207031, 19.518667221, 125.545898438, 27.928241730);	// boundary of TW for ex18. (west, south, east, north)
			this._FluidModule.arrowScale = 50000;
			this._FluidModule.arrowLengthScale = 5;
		}
		else
		{
			uvPara.boundary = new window.GeoBoundary(-180, -90, 180, 90);
			this._FluidModule.arrowScale = 250000;
			this._FluidModule.arrowLengthScale = 10;
		}

		// Add Dates
		for (let i = 0; i < uvPara.filenames.length; i++) {
			let date = this._GetDateFromFilename(uvPara.filenames[i]);
			uvPara.date.push(date);
		}

		// Load Image and Other Para.
		for (let i = 0; i < uvPara.filenames.length; i++) {
			await this._LoadUVPng(uvPara, uvPara.filenames[i]);

			let conut = i + 1;
			console.log("Data Loading Progress [" + conut + "/" + uvPara.filenames.length + "]");
		}

		// Set Lift
		const liftValue = uvPara.lift;

		// 檢查 lift key 是否存在
		if (this._AllRecord.hasOwnProperty(liftValue)) {
			console.log("已經存在相同的 key:", liftValue);
			ov.UI.Alertify.Error("高度重疊，新增失敗");
		}
		else {
			// Remove Other UI Data (因為目前無法同時顯示多層 UV，需要先將目前有的從 Record 和 List 中刪除)
			Object.keys(this._AllRecord).forEach((key) => {
				if (this._AllRecord[key].isVector)	// UV Data
				{
					this._AllRecord[key].btnUI.remove();
					delete this._AllRecord[key];
				}
			});

			// Draw UV Data
			if (uvPara.lift <= 100)	// 因高度太低，風場粒子於陸面無法顯示，強制+100
				uvPara.lift += 100;
			this._showUV(uvPara);
			this._AllRecord[liftValue] = Object.assign({}, uvPara);
			this._AllRecord[liftValue].btnUI = this._addUVComplete(uvPara.date[0], liftValue);
		}
	}
	async _LoadNewScalarData(url, date, layer)
	{
		try {
			let isFlipY = false;
//			if (layer == "tp") // ex1 Scalar 改直出 GTiff 後，無須 flipY，但 tp 仍需要
//				isFlipY = false;	// 改版為 earth2 0.7.0 後，tp 也無須 flipY

			let paraS = {
				layername: layer,
				source: null, // 	Array of <Float32Array>，可塞入時序性資料，數量需與 date[] 相同
				boundary: null,   // (w, s, e, n):(0, -90, 360, 90) => 台灣那面
				width: 0,
				height: 0,
				heightScale: 1000, // xj 有作用，但該設多少? magic number!!
				date: [], // 可塞入多時序性資料，數量需與 source 相同
				useStepLayeredColorMap: false, // true: 無漸層; false 漸層
				layeredColorMapKey: [],	// 與下一個數量一樣
				layeredColorMapValue: [],
				flipY: isFlipY,
				overlay: [],
				isVector: false,	// UV: Vector; Others: Scalar
				btnUI: null
			};

			// Load GeoTiff
			let temp = ov.UI.Alertify.Info("預報資料讀取中...");
			await this._LoadScalarGeoTiff(paraS, url);
			ov.UI.Alertify.CloseAlertify(temp);		// temp= undef，但有效

			// Get Init Date & Set Dates[]
			paraS.date = this._GetScalarDates(date, paraS.source.length);	// xj4 在想看看如何取得 InitDate

			// Get ColorMap
			this._SetScalarColorMap(paraS);

			// Draw Scalar Data
			this._showScalar(paraS);
			this._AllRecord[paraS.layername] = Object.assign({}, paraS);
			this._AllRecord[paraS.layername].btnUI = this._addScalarComplete(paraS.date[0], paraS.layername);
		}
		catch (errMsg) {
			ov.UI.Alertify.CloseAlertify(undefined);		// temp= undef，但有效
			ov.UI.Alertify.Error("預報資料讀取失敗");
			console.log(errMsg);
		}
	}
	async _GetDateForScalarFile(orig_url)
	{
		let path = orig_url.substr(0, orig_url.lastIndexOf("/"));		// ex. orig_url: "../data/earth2/latest/output_tp.tif" => "../data/earth2/latest"
		let filenames = await this._GetUVPngList(path + "/u10m_v10m");	// 以 Scalar File name，用 PHP 去 folder 內找 .png 的 fileame-date，並轉成 date string
		let date = null;
		if (filenames.length)
			date = this._GetDateFromFilename(filenames[0]);
		return date.toISOString();
	}

	_GetDateFromFilename(filename)
	{
		// Get Date from filename
		let vaDStr = filename.split('.')[0].split('-'); // ex. "2024-10-03-12-00-00.png" => date array
		let vDate0 = new Date(vaDStr[0], parseInt(vaDStr[1]) - 1, vaDStr[2], vaDStr[3], vaDStr[4], vaDStr[5]);    // date in filename is UTC+0, need to be adjust.

		let timezoneOffset = vDate0.getTimezoneOffset();
		let vDate8 = new Date(vDate0.getTime() - (timezoneOffset) * 60 * 1000); // UTC+8

		return vDate8;
	}
	_GetUVPngList(url)
	{
		return new Promise((resolve) => {
			$.post("GetWindFileList.php", {
				dir: url
			}, (data) => {
				try {
					// Add Filenames
					let filenames = JSON.parse(data);
					resolve(filenames);
				}
				catch (e) {
					alert(data);
				}
			});
		});
	}
	_LoadUVPng(uvPara, filename)
	{
		return new Promise((resolve) => {

			const windImage = new Image();
			windImage.src = uvPara.url + "/" + filename;

			let uvMax = this._GetUVMax(uvPara.lift);

			windImage.onload = async () => {

				// Load new fluidParam (uvMin/Max ,date, data)
				uvPara.uMin.push(this._LatestUMinInput.value != '' ? parseFloat(this._LatestUMinInput.value) : -uvMax);	// load from UI first
				uvPara.uMax.push(this._LatestUMaxInput.value != '' ? parseFloat(this._LatestUMaxInput.value) : uvMax);
				uvPara.vMin.push(this._LatestVMinInput.value != '' ? parseFloat(this._LatestVMinInput.value) : -uvMax);
				uvPara.vMax.push(this._LatestVMaxInput.value != '' ? parseFloat(this._LatestVMaxInput.value) : uvMax);

				uvPara.image.push(windImage);

				// Set resolution
				uvPara.width = windImage.width;
				uvPara.height = windImage.height;

				resolve(uvPara);

				console.log("Load Data: " + filename);
			};
		});
	}

	async _LoadScalarGeoTiff(para, url)
	{
		try
		{
			let tiff = await GeoTIFF.fromUrl(url);
			let image = await tiff.getImage();  // by default, the first image is read.
			let data = await image.readRasters();

			para.source = data;
			para.width = image.getWidth();
			para.height = image.getHeight();
			para.boundary = image.getBoundingBox();
		}
		catch (errMsg)
		{
			console.log("Error in GetEarth2Data: [" + errMsg + "]");
		}
	}
	_GetScalarDates(InitDate, count)
	{
		let dates = [];

		let date = new Date(InitDate);  // ex. "2021-06-01T00:00:00Z" (T...Z: UTC time)
		dates.push(date);

		for (let i = 1; i < count; i++)
		{
			let datetime = dates[0].getTime() + 6 * 3600000 * i;    // time interval: 6hr
			dates.push(new Date(datetime));
		}

		return dates;
	}
	_SetScalarColorMap(para)
	{
		let vaKey = [];
		let vaValue = [];

		if (para.layername === "tp") {

			vaKey = [   // for ex2-tp
				0.000,

				0.0005,	// 藍色
				0.001,
				0.002,
				0.003,
				0.005,

				0.0075,	// 綠色起
				0.010,
				0.015,	// 黃色起
				0.020,
				0.025,

				0.035,	// 紅色起
				0.045,
				0.055,
				0.065,	// 紫色起
				0.075,

				0.085,
				0.100,
			];
			vaValue = [ // for ex2-tp
				new ov.Color('#00000000'),

				new ov.Color('#b0ffff22'),	// 藍色
				new ov.Color('#9afdfd44'),
				new ov.Color('#01d2fd88'),
				new ov.Color('#00a3fe88'),
				new ov.Color('#0177fc88'),

				new ov.Color('#26a31a88'),	// 綠色起
				new ov.Color('#00f92f88'),
				new ov.Color('#fefd3188'),	// 黃色起
				new ov.Color('#ffd32688'),
				new ov.Color('#ffa62188'),

				new ov.Color('#ff2b0488'),	// 紅色起
				new ov.Color('#d8210288'),
				new ov.Color('#a9160288'),
				new ov.Color('#a820a288'),	// 紫色起
				new ov.Color('#da2cd088'),

				new ov.Color('#fd38fa88'),
				new ov.Color('#fdd4fc88'),
			];
/*
			vaKey = [   // for ex2-tp
				0.000,
				0.001,
				0.002,
				0.003,
				0.004,
				0.005,
				0.006,
				0.007,
				0.008,
				0.009
			];
			vaValue = [ // for ex2-tp
				new ov.Color('#2158b500'),
				new ov.Color('#0098fd88'),
				new ov.Color('#05cc6788'),
				new ov.Color('#5fe38088'),
				new ov.Color('#c9f78a88'),
				new ov.Color('#e7de8f88'),
				new ov.Color('#e6df8e88'),
				new ov.Color('#b29a7488'),
				new ov.Color('#7f5d5388'),
				new ov.Color('#b59e9988')
			];
*/
		}
		else if (para.layername === "t2m" || para.layername === "t2m_tw") {	// T°C=TK−273.15
			vaKey = [   // count:23
				-80+273.15,
				-1+273.15,

				0+273.15,
				1+273.15,
				3+273.15,
				5+273.15,
				7+273.15,

				9+273.15,
				11+273.15,
				13+273.15,
				15+273.15,
				17+273.15,

				19+273.15,
				21+273.15,
				23+273.15,
				25+273.15,
				27+273.15,

				29+273.15,
				31+273.15,
				33+273.15,
				35+273.15,
				37+273.15,

				80+273.15
			];
			vaValue = [ // count:23		// xj 修改 "')" => "88')"，2158b588	// xj new ov.Color('88'),
				new ov.Color('#035e7188'),
				new ov.Color('#0f718688'),

				new ov.Color('#217c9288'),
				new ov.Color('#30869b88'),
				new ov.Color('#4e9db088'),
				new ov.Color('#68b1c688'),
				new ov.Color('#87cad788'),

				new ov.Color('#87cad788'),
				new ov.Color('#0c904a88'),
				new ov.Color('#31a05788'),
				new ov.Color('#53b06388'),
				new ov.Color('#73c16e88'),

				new ov.Color('#73c16e88'),
				new ov.Color('#bade8788'),
				new ov.Color('#daef9388'),
				new ov.Color('#f6e68988'),
				new ov.Color('#f3c36188'),

				new ov.Color('#e99d3888'),
				new ov.Color('#e2790488'),
				new ov.Color('#ee165b88'),
				new ov.Color('#73030788'),
				new ov.Color('#844f9788'),

				new ov.Color('#7e249d88'),
			];
/*
			vaKey = [   // for ex1-t2m
				0,
				217,
				226,
				245,
				255,
				264,
				274,
				284,
				293,
				303,
				312
			];
			vaValue = [ // for ex1-t2m
				new ov.Color('#00000000'),
				new ov.Color('#2158b588'),
				new ov.Color('#0098fd88'),
				new ov.Color('#05cc6788'),
				new ov.Color('#5fe38088'),
				new ov.Color('#c9f78a88'),
				new ov.Color('#e7de8f88'),
				new ov.Color('#e6df8e88'),
				new ov.Color('#b29a7488'),
				new ov.Color('#7f5d5388'),
				new ov.Color('#b59e9988')
			];
*/
		}
		else if (para.layername === "tcwv") {

			// v1
			vaKey = [   // for ex1-tcwv
				0,
				8,
				70,
				100
			];
			vaValue = [ // for ex1-tcwv
				new ov.Color('#00000000'),
				new ov.Color('#565656AA'),
				new ov.Color('#d4d4d4DD'),
				new ov.Color('#FFFFFFFF')
			];

/*
			// v2: 低值再黑再透 => 格狀太明顯
			vaKey = [   // for ex1-tcwv
				0,
				8,
				70,
				100
			];
			vaValue = [ // for ex1-tcwv
				new ov.Color('#00000000'),
				new ov.Color('#33333355'),
				new ov.Color('#DDDDDDDD'),
				new ov.Color('#FFFFFFFF')
			];
*/
/*
			vaKey = [   // for ex1-tcwv
				0,
				8,

//				16,
//				24,
//				32,
//				40,
//				48,

				56,

//				64,
//				72,

				80,
				100
			];
			vaValue = [ // for ex1-tcwv
				new ov.Color('#00000000'),
				new ov.Color('#a7e4e288'),

//				new ov.Color('#0098fd88'),
//				new ov.Color('#05cc6788'),
//				new ov.Color('#5fe38088'),
//				new ov.Color('#c9f78a88'),
//				new ov.Color('#e7de8f88'),

				new ov.Color('#c8ebea88'),

//				new ov.Color('#b29a7488'),
//				new ov.Color('#7f5d5388'),

				new ov.Color('#deefef88'),
				new ov.Color('#ffffff88')
			];
*/
/*
			vaKey = [   // for ex1-tcwv
				0,
				8,
				16,
				24,
				32,
				40,
				48,
				56,
				64,
				72,
				80
			];
			vaValue = [ // for ex1-tcwv
				new ov.Color('#00000000'),
				new ov.Color('#2158b588'),
				new ov.Color('#0098fd88'),
				new ov.Color('#05cc6788'),
				new ov.Color('#5fe38088'),
				new ov.Color('#c9f78a88'),
				new ov.Color('#e7de8f88'),
				new ov.Color('#e6df8e88'),
				new ov.Color('#b29a7488'),
				new ov.Color('#7f5d5388'),
				new ov.Color('#b59e9988')
			];
*/
		}
		else if (para.layername === "r500") {
			vaKey = [   
				0,
				10,
				20,
				30,
				40,
				50,
				60,
				70,
				80,
				90,
				100
			];
			vaValue = [ 
				new ov.Color('#00000000'),
				new ov.Color('#2158b588'),
				new ov.Color('#0098fd88'),
				new ov.Color('#05cc6788'),
				new ov.Color('#5fe38088'),
				new ov.Color('#c9f78a88'),
				new ov.Color('#e7de8f88'),
				new ov.Color('#e6df8e88'),
				new ov.Color('#b29a7488'),
				new ov.Color('#7f5d5388'),
				new ov.Color('#b59e9988')
			];
		}
		else if (para.layername === "r850") {
			vaKey = [
				-5,
				8,
				21,
				33,
				46,
				59,
				71,
				84,
				97,
				109,
				125
			];
			vaValue = [ 
				new ov.Color('#00000000'),
				new ov.Color('#2158b588'),
				new ov.Color('#0098fd88'),
				new ov.Color('#05cc6788'),
				new ov.Color('#5fe38088'),
				new ov.Color('#c9f78a88'),
				new ov.Color('#e7de8f88'),
				new ov.Color('#e6df8e88'),
				new ov.Color('#b29a7488'),
				new ov.Color('#7f5d5388'),
				new ov.Color('#b59e9988')
			];
		}
		else if (para.layername === "mrr" || para.layername === "mrr_tw") {
			vaKey = [   // for ex18-mrr_tw or ex4-mmr
				-1,
				2.5,
				5,
				10,
				15,
				20,
				25,
				30,
				35,
				40,
				45,
				50,
				55,
				65,
				65,
			];
			vaValue = [ // for ex4-mrr
				new ov.Color('#00000000'),
				new ov.Color('#57ffff22'),
				new ov.Color('#3aa4ff44'),
				new ov.Color('#244bff66'),
				new ov.Color('#51ff0088'),
				new ov.Color('#3ec80088'),
				new ov.Color('#2c960088'),
				new ov.Color('#fefe0088'),
				new ov.Color('#fac70088'),
				new ov.Color('#f6770088'),
				new ov.Color('#f4000088'),
				new ov.Color('#bf000088'),
				new ov.Color('#8f000088'),
				new ov.Color('#f500ff88'),
				new ov.Color('#920bff88'),
			];
		}
		else {
			vaKey = [
				-0.2,
				0.00,
				0.50,
				0.75,
				1.0
			];
			vaValue = [
				new ov.Color('#00000000'),
				new ov.Color('#00ff0088'),
				new ov.Color('#ffd80088'),
				new ov.Color('#ff6a0088'),
				new ov.Color('#ff000088')
			];
		}

		para.layeredColorMapKey = vaKey;
		para.layeredColorMapValue = vaValue;
	}

	_showAllData()
	{
		// Show FluidData
		Object.keys(this._AllRecord).forEach((key) => {
			let para = this._AllRecord[key];

			if (para.isVector)	// UV Data
			{
				this._showUV(para);
			}
			else				// Scalar Data
			{
				this._showScalar(para);
            }
		});
		this._TerrainView.updateScreen();
	}
	_showUV(para)
	{
		// Show UV Data
		this._FluidModule.mode = this._ArrowStyle.checked ? 2 : 1;
		para.speedFactor = parseFloat(this._SpeedFactor.value);
		this._FluidModule.setFluidDataByParam(para);
		this._TerrainView.updateScreen();

		// Update TimeLine UI	(create timeline with date in last lift)
		if (!this._Timeline)
			this._InitTimeLine(para.date);
		this._Timeline.addLink(this._FluidModule);	// xj 若已經有 UV data，加兩次會怎樣?
	}
	_showScalar(para)
	{
		// Show Scalar Data in VisualizedDataGridOverlay
		let para2 = Object.assign({}, para);
		let bbox = para.boundary;

		para.boundary = new window.GeoBoundary(bbox[0], bbox[1], bbox[2], bbox[3]);
		para2.layername = para.layername + "_dup";
		para2.boundary = new window.GeoBoundary(bbox[0] - 360, bbox[1], bbox[2] - 360, bbox[3]);

		let overLay1 = this._TerrainView.addTerrainVisualizedDataGridOverlay(para);
		let overLay2 = this._TerrainView.addTerrainVisualizedDataGridOverlay(para2);
		this._TerrainView.updateScreen();

		para.overlay.push(overLay1);
		para.overlay.push(overLay2);	// para2 產出的 overlay2 記錄到 para1，有點怪

		// Update TimeLine UI
		if (!this._Timeline)	
			this._InitTimeLine(para.date);
		this._Timeline.addLink(overLay1);
		this._Timeline.addLink(overLay2);
	}

	_InitTimeLine(dates)
	{
		this._Timeline = new ov.Widget.Timeline({
			view: this._TerrainView,
			startTime: new Date(dates[0]),
			stopTime: new Date(dates[dates.length - 1]),
			style: { left: '70px', width: '90%' },
			isRepeat: true
		});
		this._TimelinePlayer = new ov.Widget.TimelinePlayer({
			view: this._TerrainView,
			timeline: this._Timeline,
			playSpeed: 10000,
			maxPlaySpeed: 40000,
			play: true
		});
	}

	_reset()
	{
		// Reset Timeline
		if (this._Timeline)
		{
			this._Timeline.removeLink(this._FluidModule);
			this._Timeline.remove();
			this._Timeline = undefined;
		}
		if (this._TimelinePlayer)
		{
			this._TimelinePlayer.remove();
			this._TimelinePlayer = undefined;
		}

		// Remove Data(in TerrainView), List item, and Record
		Object.keys(this._AllRecord).forEach((key) =>
		{
			let para = this._AllRecord[key];

			if (para.isVector)
			{
				// Clean UV Data
				this._FluidModule.removeFluidData();	// xj 目前無法load多層的UV，也無法單獨刪除某個 lift 的 UV
			}
			else
			{
				// Clean Scalar Data
				this._TerrainView.removeTerrainOverlay(para.overlay[0]);
				this._TerrainView.removeTerrainOverlay(para.overlay[1]);
			}

			// Remove UI in Result List
			this._AllRecord[key].btnUI.remove();	

			// Remove Record
			delete this._AllRecord[key];
		});

		this.removeAllPosValueResults();

		ov.UI.Alertify.Notify("資料已清空");
		this._TerrainView.updateScreen();
	}
	removeAllPosValueResults()
	{
		if (this._PosValueResults === undefined)
			return;

		this._PosValueResults.forEach((r) => {
			this._TerrainView.removeUI(r);
		});
		this._PosValueResults.length = 0;
	}

	_CalUVWindSpeed(u,v)
	{
		let speed = Math.sqrt(Math.pow(u, 2) + Math.pow(v, 2));
		return speed;
	}
	_CalUVBeaufortScale(speed)
	{
		const scaleLimits = [0.3, 1.6, 3.4, 5.5, 8.0, 10.8, 13.9, 17.2, 20.8, 24.5, 28.5, 32.7];
		for (let i = 0; i < scaleLimits.length; i++)
		{
			if (speed < scaleLimits[i])
			{
				return i;
			}
		}
		return 12; // 颶風級別		
	}
	_CalUVWindDirection(u, v)
	{
		let theta = Math.atan2(v, u) * (180 / Math.PI);
		return (270 - theta + 360) % 360; // 轉換為氣象風向角
	}
	_GetUVMax(lift)
	{
		let uvMax;

		switch (lift)
		{
			case 0:		// uv1000
				uvMax = 25;
				break;
			case 10:	// uv10m
				uvMax = 25;
				break;
			case 100:	// uv100m
				uvMax = 30;
				break;
			case 1500:	// uv850
				uvMax = 40;
				break;
			case 5500:	// uv500
				uvMax = 60;
				break;
			case 10000:	// uv250
				uvMax = 80;
				break;
			default:
				uvMax = 30;
				break;
		}

		return uvMax;
	}

	_addUVComplete(date: string | any, lift: string | any)
	{
		const container = document.createElement("div");
		const locateBtn = document.createElement("button");
		locateBtn.classList.add("ov-widget-smallBtn");
		const deleteBtn = locateBtn.cloneNode(true) as HTMLButtonElement;
		deleteBtn.classList.add("ov-widget-deleteBtn");
		deleteBtn.style.marginLeft = "auto";
		deleteBtn.setAttribute("title", "移除");

		deleteBtn.addEventListener("click", (event) => {

			this._Timeline.removeLink(this._FluidModule);
			this._FluidModule.removeFluidData();	// xj 目前無法load多層的UV，也無法單獨刪除某個 lift 的 UV

			delete this._AllRecord[lift];

			if (Object.keys(this._AllRecord).length === 0)
			{
				this._reset();
			}

			container.remove();
			this._TerrainView.updateScreen();
		});

		const title = date.toISOString() + ' [UV-' + lift + ']';
		container.append(title);
		container.append(deleteBtn);
		container.classList.add("ov-widget-AIForecastWidget-resultRecordnoborder");
		this._ResultList.append(container);
		ov.UI.Alertify.Notify("新增完成");
		this._ResultTabRadio.checked = true;

		return container;
	}
	_addScalarComplete(date: string | any, layer: string | any)
	{
		const container = document.createElement("div");
		const locateBtn = document.createElement("button");
		locateBtn.classList.add("ov-widget-smallBtn");
		const deleteBtn = locateBtn.cloneNode(true) as HTMLButtonElement;
		deleteBtn.classList.add("ov-widget-deleteBtn");
		deleteBtn.style.marginLeft = "auto";
		deleteBtn.setAttribute("title", "移除");
		deleteBtn.id = date.toISOString() + '_' + layer;

		deleteBtn.addEventListener("click", (event) => {

			let para = this._AllRecord[layer];

			this._Timeline.removeLink(para.overlay[0]);
			this._Timeline.removeLink(para.overlay[1]);

			this._TerrainView.removeTerrainOverlay(para.overlay[0]);
			this._TerrainView.removeTerrainOverlay(para.overlay[1]);

			delete this._AllRecord[layer];

			if (Object.keys(this._AllRecord).length === 0)
			{
				this._reset();
			}

			container.remove();
			this._TerrainView.updateScreen();
		});

		const title = date.toISOString() + ' [' + layer + ']';
		container.append(title);
		container.append(deleteBtn);
		container.classList.add("ov-widget-AIForecastWidget-resultRecordnoborder");
		this._ResultList.append(container);
		ov.UI.Alertify.Notify("新增完成");
		this._ResultTabRadio.checked = true;

		return container;
	}

	_LoadDefaultData()
	{
		this._LatestUVNewBtn.click();
		setTimeout(() => this._LatestScalarNewBtn.click(), 2000)
	}
}

// @ts-ignore 硬塞進 Widget
ov.Widget.AIForecastWidget = AIForecastWidget;
